import clientConfigApi, { axiosPosBaseEndPoint } from '../config/config'
import { wipeGuestData } from '../JS/wipeGuestData'
import { extractIdsOfStoreData } from '../layout2.0/JS/utility'

export const getItemType = (guestDetail, sku, callbackFunc, cancelSource) => {
    // console.log('cancelSource.token item type',cancelSource.token)
    return async dispatch => {
        try {
            await clientConfigApi.post(
                "/storeItemTypeList/fetch",
                {
                    "header":
                    {
                        "locationId": guestDetail.locationId,
                        "guestToken": guestDetail.guestToken
                    },
                    "payload": { storeSku: sku }
                },
                {
                    cancelToken: cancelSource.token ? cancelSource.token : ''
                }
            )
                .then(
                    (res) => {
                        console.log("/storeItemTypeList/fetch:", res)

                        if (res && res.data && res.data.payload) {
                            callbackFunc(true)
                            console.log("storeItemTypeList res", res);
                            dispatch({
                                type: 'Item_Type_List',
                                payload: res.data.payload.storeItemTypeList
                            })
                        }
                    }
                )
                .catch(
                    ({ response = {} }) => {
                        callbackFunc(false)
                        if(response.status == 401){
                            wipeGuestData({inRoomTab: process.env.REACT_APP_INROOMTAB == "true"})
                        }
                        console.log("Api failed with the status code:", response.status, response.status == 401)
                    }
                )
        } catch (e) {
            console.log("error in hcommerce api", e);
            callbackFunc(false)
            // dispatch({
            //     type: 'Store_Item_List',
            //     payload: []
            // })
        }
    }
}

export const getSubItemType = (guestDetail, id, callbackFunc, cancelSource) => {
    let subItemTypeList;
    // console.log('cancelSource.token sub item type',cancelSource.token)
    return async dispatch => {
        try {
            await clientConfigApi.post(
                "/storeItemTypeList/fetch",
                {
                    "header":
                    {
                        "locationId": guestDetail.locationId,
                        "guestToken": guestDetail.guestToken
                    },
                    "payload": { storeItemTypeId: id }
                },
                {
                    cancelToken: cancelSource.token ? cancelSource.token : ''
                }
            )
                .then(
                    (res) => {
                        console.log("/storeItemTypeList/fetch", id, res);
                        if (res && res.data && res.data.payload &&
                            res.data.payload.storeItemTypeObject) {
                            if (res.data.payload.storeItemTypeObject.storeItemSubTypeList.length > 0) {
                                subItemTypeList = res.data.payload.storeItemTypeObject.storeItemSubTypeList
                            } else {
                                subItemTypeList = []
                            }
                            callbackFunc(true)
                            //console.log("Item_Sub_Type_List", res.data.payload.storeItemTypeObject.storeItemSubTypeList);
                            // dispatch({
                            //     type: 'Item_Sub_Type_List',
                            //     payload: subItemTypeList
                            // })
                        }
                    }
                )
                .catch(
                    ({ response = {} }) => {
                        callbackFunc(false)
                        if(response.status == 401){
                            wipeGuestData({inRoomTab: process.env.REACT_APP_INROOMTAB == "true"})
                        }
                        console.log("Api failed with the status code:", response.status)
                    }
                )
        } catch (e) {
            console.log("error in hcommerce api", e);
            callbackFunc(false)
            // dispatch({
            //     type: 'Store_Item_List',
            //     payload: []
            // })
        }
    }
}

export const getItemListStoreLevel1 = (guestDetail, id, callbackFunc, cancelSource) => {
    // console.log('cancelSource.token item list',cancelSource.token)
   
    return async dispatch => {
        try {
            await clientConfigApi.post(
                "/storeItem/fetch",
                {
                    "header":
                    {
                        "locationId": guestDetail.locationId,
                        "guestToken": guestDetail.guestToken
                    },
                    "payload": { storeItemTypeId: id }
                },
                {
                    cancelToken: cancelSource.token ? cancelSource.token : ''
                }
            )
                .then(
                    (res) => {
                        let itemList=[];
                        console.log("/storeItem/fetch", id, res);
                       
                        if (res && res.data && res.data.payload && res.data.payload.storeItemList) {
                            //console.log("Store_Item_List", res.data.payload);
                            if(res.data.payload.storeItemList.length > 0)
                            itemList = res.data.payload.storeItemList  
                                                      
                        }

                        // console.log("Updating itemList",itemList);
                        callbackFunc(true)
                        dispatch({
                            type: 'Store_Item_List',
                            payload: itemList
                        })
                    }
                )
                .catch(
                    ({ response = {} }) => {
                        callbackFunc(false);
                        console.log("Api failed with the status code:", response.status)
                        if(response.status == 401){
                            wipeGuestData({inRoomTab: process.env.REACT_APP_INROOMTAB == "true"})
                        } else {
                            // dispatch({
                            //     type: 'Store_Item_List',
                            //     payload: []
                            // })
                        }
                        if(window.FireBasePlugin){
                            window.FirebasePlugin.logMessage("API failed /storeItem/fetch reponse = ", response.status);
                            window.FirebasePlugin.logError("Error in calling /storeItem/fetch guestDetail")
                          }
                    }
                )
        } catch (e) {
            console.log("error in hcommerce api", e);
            if(window.FireBasePlugin){
                // window.FirebasePlugin.logMessage("Error in calling /storeItem/fetch guestDetail = " + guestDetail);
                window.FirebasePlugin.logError("Error in calling /storeItem/fetch" + e)
              }
            callbackFunc(false);
        }
    }
}

export const getItemList = (guestDetail, id, callBackFunc, cancelSource) => {
    
    return async dispatch => {
        try {
            await clientConfigApi.post(
                "/storeItem/fetch",
                {
                    "header":
                    {
                        "locationId": guestDetail.locationId,
                        "guestToken": guestDetail.guestToken
                    },
                    "payload": { storeItemSubTypeId: id }
                },
                {
                    cancelToken: cancelSource.token ? cancelSource.token : ''
                }
            )
                .then(
                    (res) => {
                        let itemList=[];
                        console.log("/storeItem/fetch", id, res);
                        if (res && res.data && res.data.payload && res.data.payload.storeItemList.length > 0) {
                            //console.log("Store_Item_List", res.data.payload);
                            itemList = res.data.payload.storeItemList
                            
                        }
                        callBackFunc(true);

                        dispatch({
                            type: 'Store_Item_List',
                            payload: itemList
                        })
                    }
                )
                .catch(
                    ({ response = {} }) => {
                        callBackFunc(false)
                        console.log("Api failed with the status code:", response.status)
                    }
                )
        } catch (e) {
            console.log("error in hcommerce api", e);
            callBackFunc(false)
            // dispatch({
            //     type: 'Store_Item_List',
            //     payload: []
            // })
        }
    }
}

export const getUpSellItem = (guestDetail, itemId) => {
    let itemList = [];
    return async dispatch => {
        try {
            await clientConfigApi.post(
                "/storeItemUpsell/fetch",
                {
                    "header":
                    {
                        "locationId": guestDetail.locationId,
                        "guestToken": guestDetail.guestToken
                    },
                    "payload": { storeItemId: itemId }
                }
            )
                .then(
                    (res) => {
                        console.log("/storeItemUpsell/fetch: ", res);
                        if (res && res.data && res.data.payload && res.data.payload.storeItemList) {
                            //console.log("Store_Item_List", res.data.payload);
                            dispatch({
                                type: 'Set_Upsell_Item',
                                payload: res.data.payload.storeItemList
                            })
                        }else{
                            // dispatch({
                            //     type: 'Set_Upsell_Item',
                            //     payload: []
                            // })
                        }
                    }
                )
                .catch(
                    ({ response = {} }) => {
                        if(response.status == 401){
                            wipeGuestData({inRoomTab: process.env.REACT_APP_INROOMTAB == "true"})
                        }
                        console.log("Api failed with the status code:", response.status)
                    }
                )
        } catch (e) {
            console.log("error in hcommerce api", e);
        }
    }
}

export const getDeliveryLocation = (sku) => {
    return async dispatch => {
        try {
            await clientConfigApi.post(
                "/store/deliveryLocations",
                {
                    "header": {
                    },
                    "payload": { storeSku: sku }
                }
            )
                .then(
                    (res) => {
                        console.log("delivery location", res);
                        if (res && res.data && res.data.header.status.code === "SUCCESS") {
                            dispatch({
                                type: 'Set_Delivery_Locations',
                                payload: res.data.payload.deliveryLocations
                            })
                        }
                    }
                )
                .catch(
                    ({ response = {} }) => {
                        if(response.status == 401){
                            wipeGuestData({inRoomTab: process.env.REACT_APP_INROOMTAB == "true"})
                        }
                        console.log("delivery location api failed with the status code:", response.status)
                    }
                )
        } catch (e) {
            console.log("error in hcommerce api", e);
        }
    }
}

function stringToHash(string) {
                  
    var hash = 0;
    let i,j, char
      
    if (string.length == 0) return hash;
      
    for (i = 0; i < string.length; i++) {
        char = string.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash;
    }
      
    return hash;
}


const getgroupedStoreItemTypeListData = (storeInfoData) => {

    let groupedStoreItemTypeList = [];

    storeInfoData.storeItemTypeInfo.forEach((currentStoreItemTypeInfo) => {
        // Extract and filter store items
        const currentStoreItemListIds = extractIdsOfStoreData(
            currentStoreItemTypeInfo.id,
            storeInfoData.storeItemStoreItemTypeInfo,
            'storeItem',
            'storeItemType'
        );
        
        const storeItemList = storeInfoData.storeItemInfo.filter((currentStoreItemInfo) =>
            currentStoreItemListIds.includes(currentStoreItemInfo.id)
        );

        // Extract and filter store sub-menu items
        const currentStoreSubMenuListIds = extractIdsOfStoreData(
            currentStoreItemTypeInfo.id,
            storeInfoData.storeItemTypeSubTypeInfo,
            'storeItemSubType',
            'storeItemType'
        );

        const storeSubMenuList = storeInfoData.storeItemSubTypeInfo.filter((currentStoreSubTypeInfo) =>
            currentStoreSubMenuListIds.includes(currentStoreSubTypeInfo.id)
        );

        // Assign filtered lists to current item type info
        currentStoreItemTypeInfo.storeItemList = storeItemList;
        currentStoreItemTypeInfo.itemSubTypeList = storeSubMenuList;

        // Add the updated item type info to the grouped list
        groupedStoreItemTypeList.push(currentStoreItemTypeInfo);
    });

    return groupedStoreItemTypeList;
};

export const getStoreInfo = (sku, guestDetail, callback) => {

    let room = localStorage.getItem("room")
    let guestLogin = room && room != "null"

    return async dispatch => {
        try {
            await clientConfigApi.post(
                "/storeInfo/fetch",
                {
                    "header": {
                        "sessionToken": localStorage.getItem('GuestJourneySessionToken')
                    },
                    "payload": { 
                        storeSku: sku,
                        reservationNumber: guestLogin ? guestDetail.reservationNumber : "",
                        locationId: guestLogin ? guestDetail.locationId : "",
                        // hashCode: JSON.parse(localStorage.getItem("hcommerceResponse")) && parseInt(localStorage.getItem("storeInfoHash"))
                    }
                }
            )
                .then(
                    (response) => {
                        console.log("getStoreInfo Response: ", response);
                        if (response && response.data && response.data.header.status.statusCode === "SUCCESS") {
                            let res;
                            if(response.data.payload){
                                res = response;
                                console.log("hcommerce data from api response")
                                console.log('storeInfo Hash', stringToHash(JSON.stringify(response.data)));
                                // localStorage.setItem("storeInfoHash", stringToHash(JSON.stringify(response.data)))
                                // localStorage.setItem("hcommerceResponse", JSON.stringify(response))
                            }
                            else {
                                console.log("hcommerce data from local")
                                res = JSON.parse(localStorage.getItem("hcommerceResponse"))
                            }
                                // dispatch({
                                //     type: 'Get_StoreInfo',
                                //     payload: res.data.payload.storeInfo
                                // }) 

                                let groupedStoreItemTypeList = getgroupedStoreItemTypeListData(res.data.payload);

                                dispatch({
                                    type: "Grouped_Store_Item_Type_List",
                                    payload: groupedStoreItemTypeList
                                })

                                dispatch({//
                                    type: 'Store_Item_Type_Sub_Type_Info',
                                    payload: res.data.payload.storeItemTypeSubTypeInfo
                                })

                                dispatch({//
                                    type: 'Item_Type_List',
                                    payload: res.data.payload.storeItemTypeInfo
                                })

                                dispatch({//
                                    type: 'Set_Upsell_Item',
                                    payload: res.data.payload.upsellItemInfo
                                })

                                dispatch({//
                                    type: 'Get_StoreInfo',
                                    payload: res.data.payload.storeInfo
                                })

                                dispatch({//
                                    type: 'Hcommerce_Pricing_Via_Toast',
                                    payload: res.data.payload.posType && res.data.payload.posType == "TOAST" ? true :false 
                                })

                                dispatch({
                                    type: 'Item_Add_Ons_Info',
                                    payload: res.data.payload.itemAddOnsInfo
                                })

                                dispatch({
                                    type: "ADDON_GROUP_TYP_ITEM_ADDON_INFO",
                                    payload: res.data.payload.addOnGroupTypeItemAddonInfo || []
                                })

                                dispatch({
                                    type: "STORE_ITEM_ADDON_GROUP_INFO",
                                    payload: res.data.payload.storeItemAddOnGroupInfo || []
                                })

                                dispatch({
                                    type: "ADDON_GROUP_TYPE_INFO",
                                    payload: res.data.payload.addOnGroupTypeInfo || []
                                })

                                dispatch({
                                    type: 'Store_Item_Store_Upsell_Item_Info',
                                    payload: res.data.payload.storeItemStoreUpsellItemInfo
                                })

                                dispatch({//
                                    type: 'Item_Sub_Type_List',
                                    payload: res.data.payload.storeItemSubTypeInfo
                                })

                                dispatch({
                                    type: 'Store_Item_Store_Item_Sub_Type_Info',
                                    payload: res.data.payload.storeItemStoreItemSubTypeInfo
                                })

                                dispatch({
                                    type: 'Store_Item_Store_Item_Type_Info',
                                    payload: res.data.payload.storeItemStoreItemTypeInfo
                                })

                                dispatch({//
                                    type: 'Set_Delivery_Locations',
                                    payload: res.data.payload.deliveryLocationsInfo
                                })

                                dispatch({//
                                    type: 'Store_Item_List',
                                    payload: res.data.payload.storeItemInfo
                                })

                                dispatch({//
                                    type: 'Sub_Type_Sub_Type_Info',
                                    payload: res.data.payload.subTypeSubTypeMapping
                                })

                           // localStorage.setItem('displayDeliveyTime', res.data.payload.storeInfo.displayDeliveyTime); 
                        }
                    if(callback) callback(true);
                    }
                )
                .catch(
                    ({ response = {} }) => {
                        if(response.status == 401){
                            wipeGuestData({inRoomTab: process.env.REACT_APP_INROOMTAB == "true"})
                        }
                        console.log("getStoreInfo api failed with the status code:", response.status, response)
                        if(callback) callback(false, response && response.data && response.data.header && response.data.header.status.msg || response.data.header.status.message);
                    }
                )
        } catch (e) {
            console.log("error in hcommerce api", e);
        }
    }
}



export const getToastPricing = async (payload, callback) => {

        try {
            await axiosPosBaseEndPoint.post(
                "/toast/fetchOrderPrice",
                 payload
            )
                .then(
                    (response) => {
                        console.log("fetchOrderPrice Response: ", response);
                        if (response && response.data && response.data.header.status.code === "SUCCESS") {
                             
                              
                            if(callback) callback(true, response.data.payload);

                         }else {
                            if(callback) callback(false,  response && response.data && response.data.header && response.data.header.status.msg || response.data.header.status.message);
                         }
                        
                    }
                )
                .catch(
                    ({ response = {} }) => {
                        if(response.status == 401){
                            wipeGuestData({inRoomTab: process.env.REACT_APP_INROOMTAB == "true"})
                        }
                        console.log("fetchOrderPrice api failed with the status code:", response.status, response)
                        if(callback) callback(false, response && response.data && response.data.header && response.data.header.status.msg || response.data.header.status.message);
                    }
                )
        } catch (e) {
            console.log("error in hcommerce api", e);
            if(callback) callback(false, "Something went wrong. ");
        }
}

export const sendOrder = (deliverLocation, guestDetail, orderTime, comment, savedOrders, currentWidget, orderItemList,base64Map,mapUrl,gratitudeValue, callBackFromOrderAPI, guestemail, guestCount, otherCharges) => {
    let token = localStorage.getItem("GuestJourneySessionToken")
    let room = localStorage.getItem("room")
    let guestLogin = room && room != "null"

    return async dispatch => {
        try {
            await clientConfigApi.post(
                "/storeItems/order",
                {
                    "header":
                    {
                        "locationId": guestLogin && guestDetail.location,
                        "guestToken": guestLogin && guestDetail.guestToken,
                        "loggedinGuestToken": guestLogin && guestDetail.guestToken,
                        "sessionToken": token,
                        "guestEmail": guestemail || "",
                        "dataSource": "guestJourney" // added for differing the GA events from TV
                    },
                    "payload": {
                        "orderDeliveryTime": orderTime,
                        "guestReservationNumber": guestLogin && guestDetail.reservationNumber,
                        "orderDeliveryAt": deliverLocation,
                        "orderDeliveryLocationImage": base64Map,
                        "orderDeliveryLocationURL": mapUrl,
                        "guestComment": comment,
                        "guestCount": guestCount || 1,
                        "storeSku": currentWidget.storeSku,
                        "gratitudeTipValue": gratitudeValue,
                        // "taxAmount" : otherCharges.taxAmount,
                        // "serviceCharge" : otherCharges.serviceCharge,
                        "orderDetails": {
                            "orderItemsList": orderItemList
                        },
                        "sourceApp": "guestJourneyApp",
                        "platform": window.device ? window.device.platform : "Web",
                    }
                }
            )
                .then(
                    (res) => {
                        console.log("order API response", res);
                        if (res && res.data && res.data.header) {
                            if (res.data.header.status.code === "SUCCESS") {
                                console.log("API success");
                                callBackFromOrderAPI(true);
                            } else if (res.data.header.status.code === "FAILD") {
                                console.log("API success, But get faild response:", res.data.header.status.msg);
                                callBackFromOrderAPI(false);
                            } else {
                                console.log("API success, But there unknown issue:", res.data.header.status.msg);
                                callBackFromOrderAPI(false);
                            }
                        }
                    }
                )
                .catch(
                    ({ response = {} }) => {
                        console.log("Api failed with the status code:", response.status);
                        callBackFromOrderAPI(false, response.data.header.status.msg);
                        if(response.status == 401){
                            wipeGuestData({inRoomTab: process.env.REACT_APP_INROOMTAB == "true"})
                        }
                        if(window.FireBasePlugin){
                            // window.FirebasePlugin.logMessage("API failed sendOrder 'Hcommerce' /storeItems/order = " + response.status);
                            window.FirebasePlugin.logError("API failed sendOrder() 'Hcommerce' /storeItems/order = " + response.status)
                          }
                    }
                )
        } catch (e) {
            console.log("error in hcommerce api", e);
            callBackFromOrderAPI(false);
            if(window.FireBasePlugin){
                // window.FirebasePlugin.logMessage("Error in calling /storeItem/fetch guestDetail = " + guestDetail);
                window.FirebasePlugin.logError("Error in calling sendOrder() API /storeItems/order" + e)
              }
        }
    }
}

export const changePage = (nextPage) => {
    return {
        type: 'Set_hcommerce_Page',
        payload: nextPage
    }
}

export const setItemTypeList = (itemType) => {
    return {
        type: "Item_Type_List",
        payload: itemType
    }
}

export const selectedStoreItemType = (storeItemType) => {
    return {
        type: 'Set_Store_Item_Type',
        payload: storeItemType
    }
}

export const selectedSubItem = (subItemType) => {
    return {
        type: 'Selected_Sub_Item',
        payload: subItemType
    }
}

export const selectedFood = (selectedItem) => {
    return {
        type: 'Selected_Food',
        payload: selectedItem
    }
}

export const setDefaultSubTypeList = (list) => {
    return {
        type: 'Item_Sub_Type_List',
        payload: list
    }
}

export const defaultStoreItemList = (list) => {
    return {
        type: 'Store_Item_List',
        payload: list
    }
}

export const setTotalOrderPrice = (totalPrice) => {
    return {
        type: 'Set_Total_Order_Price',
        payload: totalPrice
    }
}

export const selectedNavComponent = (navComponent) => {
    return {
        type: 'Selected_NavComponent',
        payload: navComponent
    }
}

export const setSelectedLocation = (location) => {
    return{
        type: "Set_selected_location",
        payload: location
    };
}

export const setHCommerceSavedOrders = (orders) => {
    return{
        type: "Set_hCommerce_saved_orders",
        payload: orders
    };
}

export const setUpsellItem = (item) => {
    return{
        type: "Set_Upsell_Item",
        payload: item
    }
}

export const setStoreInfo = (infoObj) => {
    return{
        type: "Get_StoreInfo",
        payload: infoObj
    }
}

export const setSelectedSubItemList = (list) => {
    return{
        type: "Set_Selected_Sub_Item_List",
        payload: list
    }
}

export const setSelectedSubItemListStoreLevel2 = (list) => {
    return{
        type: "set_Selected_Sub_Item_List_Store_Level2",
        payload: list
    }
}

export const setSelectedStoreItemList = (list) => {
    return{
        type: "Set_Selected_Store_Item_List",
        payload: list
    }
}

export const setSelectedStoreSubMenuList = (list) => {
    return{
        type: "Set_Selected_Store_Sub_Menu_List",
        payload: list
    }
}

export const setSelectedSubTypeSubMenuList = (list) => {
    return{
        type: "Set_Selected_SubType_Sub_Menu_List",
        payload: list
    }
}

export const setSelectedSubItemStoreLevel2 = (obj) => {
    return{
        type: "Set_Selected_SubItem_StoreLevel2",
        payload: obj
    }
}

export const resetHcommerce = (list) => {
    return{
        type: "Reset_Hcommerce",
        payload: list
    }
}